var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:['d-flex', 'justify-content-between', 'lista', ("lista-" + _vm.cor)]},[_c('li',[_vm._v(" "+_vm._s(_vm.ticket)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }